import React from 'react';
import c from 'classnames';
import s from './InputSuccessMessage.scss';
/**
 * A success message! Meant to follow an input field.
 */ const InputSuccessMessage = ({ children , className ,  })=>{
    return /*#__PURE__*/ React.createElement("span", {
        className: c(s['root'], className)
    }, children);
};
InputSuccessMessage.displayName = 'InputSuccessMessage';
export default InputSuccessMessage;
